/* Offer 1 buy box: supply subscriptions + one-time row + gift accordion.
 *
 * Selection state is a single radio group across both the subscription tiers
 * and the one-time row, so picking "One Time Sample" genuinely replaces the
 * subscription rather than stacking on top of it.
 */
(function () {
  'use strict';

  function init(root) {
    var core = window.NutsolaOfferBox;
    if (!core) { console.warn('[offer-supply] offer-boxes.js did not load'); return; }

    var offers = Array.prototype.slice.call(root.querySelectorAll('[data-offer]'));
    if (!offers.length) return;

    var cta = root.querySelector('[data-offer-cta]');
    var errorEl = root.querySelector('[data-offer-error]');
    var flavorBtns = Array.prototype.slice.call(root.querySelectorAll('[data-flavor]'));
    var flavorLabel = root.querySelector('[data-flavor-current]');
    var ctaLabel = (cta && cta.textContent.trim()) || 'ADD TO CART';

    var state = {
      offer: 'tier-' + (root.getAttribute('data-default-tier') || '1'),
      flavor: root.getAttribute('data-default-flavor') || ''
    };

    // The initial paint must not touch the gallery: the section already
    // starts slick on the default flavor's cover (or the first photo).
    paint.lastCoverFlavor = state.flavor;

    function offerEl(key) {
      for (var i = 0; i < offers.length; i++) {
        if (offers[i].getAttribute('data-offer') === key) return offers[i];
      }
      return null;
    }

    function paint() {
      offers.forEach(function (el) {
        var on = el.getAttribute('data-offer') === state.offer;
        el.classList.toggle('is-selected', on);
        var radio = el.querySelector('input[type="radio"]');
        if (radio) radio.checked = on;
      });

      flavorBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-flavor') === state.flavor;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && flavorLabel) flavorLabel.textContent = btn.getAttribute('data-flavor-label') || '';
        // Only move the gallery when the flavor actually changed, so picking
        // a tier does not yank the shopper back to the cover slide.
        if (on && state.flavor !== paint.lastCoverFlavor) {
          paint.lastCoverFlavor = state.flavor;
          core.showCover(root, btn.getAttribute('data-cover'));
        }
      });

      core.paintFlavorLines(root, state.flavor);

      var el = offerEl(state.offer);
      if (el && cta) {
        core.renderCta(cta, el.getAttribute('data-cta-compare'), el.getAttribute('data-cta-price'), ctaLabel);
      }
      if (errorEl) errorEl.textContent = '';
    }

    /* One delegated listener: a click anywhere in a tier selects it, except on
     * the gifts accordion or a link inside the bullet list. */
    root.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-future-toggle]');
      if (toggle) {
        var wrap = toggle.closest('[data-future-root]');
        var panel = wrap && wrap.querySelector('[data-future-panel]');
        if (panel) {
          var open = panel.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      var flavor = e.target.closest('[data-flavor]');
      if (flavor && root.contains(flavor)) {
        state.flavor = flavor.getAttribute('data-flavor');
        paint();
        return;
      }

      if (e.target.closest('a')) return;

      var offer = e.target.closest('[data-offer]');
      if (offer && root.contains(offer)) {
        state.offer = offer.getAttribute('data-offer');
        paint();
      }
    });

    if (cta) {
      cta.addEventListener('click', function () {
        var el = offerEl(state.offer);
        if (!el) return;

        var items = core.resolveItems(core.parseRecipe(el.getAttribute('data-recipe')), state.flavor, null);
        if (!items.length) {
          if (errorEl) errorEl.textContent = 'This option is not available for the selected flavor.';
          return;
        }

        cta.classList.add('is-loading');
        cta.disabled = true;
        if (errorEl) errorEl.textContent = '';

        core.addToCart(items)
          .catch(function (err) {
            if (errorEl) errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          })
          .then(function () {
            cta.classList.remove('is-loading');
            cta.disabled = false;
          });
      });
    }

    paint();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-offer-supply]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor re-renders the block on every setting change. */
  document.addEventListener('shopify:section:load', boot);
})();
